import React, { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { IoSunnyOutline, IoMoonOutline } from 'react-icons/io5';
import styles from './ThemeToggle.module.css';

interface ThemeToggleProps {
  isWideScreenOnly?: boolean; // Add prop for conditional visibility
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ isWideScreenOnly = false }) => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('ThemeToggle must be used within a ThemeProvider');
  }

  const { theme, toggleTheme } = context;

  return (
      <div
          className={`${styles.toggleContainer} ${
              theme === 'light' ? styles.lightMode : styles.darkMode
          } ${isWideScreenOnly ? styles.wideScreenOnly : ''}`} // Apply visibility class
          onClick={toggleTheme}
      >
        <div className={styles.icon}>
          {theme === 'dark' ? <IoMoonOutline size={18} /> : <IoSunnyOutline size={18} />}
        </div>
        <div
            className={styles.switchWrapper}
            onClick={(e) => e.stopPropagation()} // Prevent container click from interfering
        >
          <input
              type="checkbox"
              id="theme-switch"
              className={styles.switchInput}
              checked={theme === 'dark'}
              onChange={toggleTheme}
          />
          <label htmlFor="theme-switch" className={styles.switchLabel}>
            <span className={styles.switchHandle} />
          </label>
        </div>
      </div>
  );
};

export default ThemeToggle;
